"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var design_system_theme_1 = require("@unmind/design-system-theme");
var polished_1 = require("polished");
var styled_components_1 = __importStar(require("styled-components"));
var responsive_1 = require("../../utils/responsive");
/**
 * Our primary container which sets width and horizontal padding appropriately across breakpoints.
 * Use this to wrap your UI in order to ensure all screens have a consistent width and guttering.
 */
exports.Container = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding-left: ", ";\n  padding-right: ", ";\n  margin: 0 auto;\n  width: 100%;\n\n  ", "\n\n  ", "\n  \n  ", "\n"], ["\n  padding-left: ", ";\n  padding-right: ", ";\n  margin: 0 auto;\n  width: 100%;\n\n  ", "\n\n  ", "\n  \n  ", "\n"])), (0, polished_1.rem)(24), (0, polished_1.rem)(24), (0, responsive_1.small)((0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n    width: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n    width: ", ";\n  "])), (0, polished_1.rem)(32), (0, polished_1.rem)(32), (0, polished_1.rem)(design_system_theme_1.Breakpoints.S))), (0, responsive_1.medium)((0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n    width: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n    width: ", ";\n  "])), (0, polished_1.rem)(40), (0, polished_1.rem)(40), (0, polished_1.rem)(design_system_theme_1.Breakpoints.M))), (0, responsive_1.large)((0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: ", ";\n  "], ["\n    width: ", ";\n  "])), (0, polished_1.rem)(design_system_theme_1.Breakpoints.L))));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
